/** Known CPC packages / entry functions shown when chain metrics are sparse. */

function viteEnv(name: string): string | undefined {
	const v = import.meta.env[name];
	return typeof v === 'string' && v.length > 0 ? v : undefined;
}

export type CpcPackageHint = {
	package: string;
	module: string;
	function: string;
	label?: string;
};

const FRAMEWORK = '0x0000000000000000000000000000000000000000000000000000000000000002';

/** Seed rows for Popular Packages on LOCAL (merged with scanned tx counts). */
export function getCpcPackageHints(): CpcPackageHint[] {
	const clob = viteEnv('VITE_CPC_CLOB_PACKAGE_ID');
	const bridge = viteEnv('VITE_CPC_BRIDGE_PACKAGE_ID');

	const hints: CpcPackageHint[] = [
		{ package: FRAMEWORK, module: 'rwax', function: 'transfer', label: 'RWAX transfer' },
		{ package: FRAMEWORK, module: 'sui', function: 'transfer', label: 'SUI transfer' },
	];

	if (clob) {
		hints.push(
			{ package: clob, module: 'clob', function: 'place_bid', label: 'CLOB place_bid' },
			{ package: clob, module: 'clob', function: 'place_ask', label: 'CLOB place_ask' },
			{ package: clob, module: 'clob', function: 'cancel_order', label: 'CLOB cancel' },
			{ package: clob, module: 'data', function: 'mint', label: 'DATA mint' },
		);
	}

	if (bridge) {
		hints.push(
			{ package: bridge, module: 'bridge', function: 'lock_for_bnb', label: 'Bridge lock' },
		);
	}

	return hints;
}
